import { useTranslation } from 'react-i18next';
import { Textfield } from '@digdir/designsystemet-react';

import { useOmBoligenFormContext } from '../utils';
import { parseNorwegianFormattedNumber } from '../../../../../../utils/utils';
import { useOmBoligenValidation } from '../hooks/useOmBoligenValidation';

export const BruksarealInput = () => {
  const { t } = useTranslation();
  const { register, formState } = useOmBoligenFormContext();
  const { validateBruksareal } = useOmBoligenValidation();

  const error = formState.errors.bygginfo?.area?.message;

  return (
    <Textfield
      type="text"
      inputMode="decimal"
      label={t('register.bygningsdetaljer.totalBRA.label')}
      suffix={t('register.solar.form.suffix.sqm')}
      error={error}
      {...register('bygginfo.area', {
        setValueAs: (value) => parseNorwegianFormattedNumber(value),
        validate: validateBruksareal
      })}
    />
  );
};
